import { deleteFileIsolated } from 'commons/service/client/documentFile'
import { WriteHook, useMutationManager } from 'state-manager'

export const useDeleteDocumentFileIsolated: WriteHook<number, unknown> = (opts) =>
  useMutationManager<number, unknown>(deleteFileIsolated, opts)
